module.exports = __webpack_public_path__ + "static/img/ap3.b3cd7aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap3.jpg
// module id = XQK7
// module chunks = 1